import { render, staticRenderFns } from "./AccountSettingsVueComponent.vue?vue&type=template&id=3dac1943&"
import script from "./AccountSettingsVueComponent.vue?vue&type=script&lang=ts&"
export * from "./AccountSettingsVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettingsVueComponent.vue?vue&type=style&index=0&id=3dac1943&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports